import { collection_name } from "@/types/projectConsts";
import { asyncPostItem } from "@/setup/flexbiz-api-provider/coreFunction";

export const postContact = async (inputValues: any) => {
  return await asyncPostItem({
    collection_name: collection_name.ECOM_CONTACTUS,
    data: inputValues,
  });
};
